import type { ISODateTimeString } from '../BrandedTypes'

export const Stakeholder = {
  V1: {
    Added: 'Stakeholders.V1.StakeholderAdded',
    GeneralInfoChanged: 'Stakeholders.V1.StakeholderGeneralInfoChanged',
    InternalIdentificationNumbersChanged:
      'Stakeholders.V1.StakeholderSystemReferenceNumbersChanged',
    OfficialBusinessNumbersChanged:
      'Stakeholders.V1.StakeholderOfficialBusinessNumbersChanged',
    PostalAddressChanged: 'Stakeholders.V1.StakeholderPostalAddressChanged',
    VisitAddressChanged: 'Stakeholders.V1.StakeholderVisitAddressChanged',
    BillingDetailsChanged: 'Stakeholders.V1.StakeholderBillingDetailsChanged',
    Removed: 'Stakeholders.V1.StakeholderRemoved',
    Restored: 'Stakeholders.V1.StakeholderRestored',
    StakeholderContactAdded: 'Stakeholders.V1.StakeholderContactAdded',
    StakeholderContactUpdated:
      'Stakeholders.V1.StakeholderContactDetailsUpdated',
    StakeholderContactRemoved: 'Stakeholders.V1.StakeholderContactRemoved'
  }
} as const

export type StakeholderContactAddedSignalRPayload = {
  contactId: string
  contactType: string
  department: string | null
  directLine: string | null
  email: string | null
  firstName: string | null
  jobTitle: string | null
  lastName: string | null
  mobilePhone: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

export type StakeholderContactUpdatedSignalRPayload = {
  contactId: string
  contactType: string
  department: string | null
  directLine: string | null
  email: string | null
  firstName: string | null
  jobTitle: string | null
  lastName: string | null
  mobilePhone: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

export type StakeholderContactDeletedSignalRPayload = {
  contactId: string
  contactType: string
  firstName: string | null
  lastName: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

export type StakeholderAddedSignalRPayload = {
  email?: string
  name: string
  occuredAt: ISODateTimeString
  stakeholderId: string
  phoneNumber?: string
  postalAddress?: string
  postalCountryCode?: string
  shortName?: string
  visitAddress?: string
  visitAddressSameAsPostal?: boolean
  visitCountryCode?: string
  stakeholderType: string
}

export type StakeholderVisitAddressChangedSignalRPayload = {
  name: string
  occuredAt: ISODateTimeString
  shortName: string | null
  stakeholderId: string
  stakeholderType: string
  visitAddress: string | null
  visitAddressCountryCode: string | null
  visitAddressSameAsPostal: boolean
}

export type StakeholderPostalAddressChangedSignalRPayload = {
  name: string
  occuredAt: ISODateTimeString
  postalAddress: string | null
  postalAddressCountryCode: string | null
  shortName: string | null
  stakeholderId: string
  stakeholderType: string
}

export type StakeholderGeneralInfoChangedSignalRPayload = {
  email?: string
  name: string
  occuredAt: ISODateTimeString
  phoneNumber?: string
  shortName?: string
  stakeholderId: string
  stakeholderType: string
}

export type StakeholderInternalIdentificationNumbersChangedSignalRPayload = {
  clientNumber: string | null
  name: string
  occuredAt: ISODateTimeString
  shortName: string | null
  stakeholderId: string
  stakeholderType: string
  vendorNumber: string | null
}

export type StakeholderOfficialBusinessNumbersChangedSignalRPayload = {
  eoriNumber: string | null
  name: string
  occuredAt: ISODateTimeString
  shortName: string | null
  stakeholderId: string
  stakeholderType: string
  taxIdentificationNumber: string | null
}

export type StakeholderBillingDetailsChangedSignalRPayload = {
  billingAddress: string | null
  billingAddressCountryCode: string | null
  billingAddressSameAsPostal: boolean
  billingCurrencyCode: string | null
  invoiceEmail: string | null
  name: string
  occuredAt: ISODateTimeString
  paymentTermsPeriodInDays: number | null
  paymentTermsUseRunningMonth: boolean | null
  shortName: string | null
  stakeholderId: string
  stakeholderType: string
  useDefaultBillingCurrency: boolean
  useDefaultPaymentTerms: boolean
}

export type StakeholderRemovedSignalRPayload = {
  name: string
  occuredAt: ISODateTimeString
  shortName?: string
  stakeholderId: string
  stakeholderType: string
}

export type StakeholderRestoredSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
  name: string
  shortName?: string
  stakeholderType: string
}
